import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"Folder-sparkle, plus"} maskId="square-filled-radius-0-stroke-1-IconFolderSparkle"><path d="M10.2676 3L12.2676 6H22V20H6.85547L7.17285 19.1729L10 18.0869V15.9131L7.17285 14.8262L6.08691 12H3.91309L2.82617 14.8262L2 15.1436V3H10.2676Z" fill="currentColor"/><path d="M5.4 13H4.6L3.6 15.6L1 16.6V17.4L3.6 18.4L4.6 21H5.4L6.4 18.4L9 17.4V16.6L6.4 15.6L5.4 13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderSparkle;
